(function fixCarouselSnap(){
  document.addEventListener('carousel:settle', function(e){
    var el = e.target;
    if (!el || el.tagName !== 'SCROLL-CAROUSEL') return;

    if (el.style.scrollSnapType === 'none') {
      el.style.removeProperty('scroll-snap-type');
    }

    if (e.detail && e.detail.index === 0 && el.classList.contains('peeking') && el.scrollLeft > 0) {
      el.scrollTo({ left: 0, behavior: 'auto' });
    }
  }, true);

  document.addEventListener('scrollend', function(e){
    var el = e.target;
    if (!el || el.tagName !== 'SCROLL-CAROUSEL') return;

    if (el.style.scrollSnapType === 'none') {
      el.style.removeProperty('scroll-snap-type');
    }
  }, true);
})();

(function initCardSwatchArrows(){
  function setup(wrap){
    var track = wrap.querySelector('[data-card-swatches-track]');
    var prev = wrap.querySelector('[data-swatches-prev]');
    var next = wrap.querySelector('[data-swatches-next]');
    if (!track || !prev || !next) return;
    if (wrap.__swatchArrowsBound) return;
    wrap.__swatchArrowsBound = true;

    function getUnit(){
      var swatch = track.querySelector('.color-swatch');
      if (!swatch) return 24;
      var gap = parseFloat(getComputedStyle(track).gap) || 5;
      return swatch.getBoundingClientRect().width + gap;
    }

    function clampWidth(){
      if (window.innerWidth < 700) {
        track.style.maxWidth = '';
        return;
      }
      var swatch = track.querySelector('.color-swatch');
      if (!swatch) return;

      var gap = parseFloat(getComputedStyle(track).gap) || 5;
      var swatchW = swatch.getBoundingClientRect().width;
      var unit = swatchW + gap;
      var total = track.querySelectorAll('.color-swatch').length;
      var contentWidth = total * unit - gap;

      track.style.maxWidth = '';
      var cardWidth = wrap.closest('product-card').clientWidth;

      if (contentWidth <= cardWidth) return;

      var available = cardWidth - 32;
      var count = Math.floor((available + gap) / unit);
      if (count < 1) count = 1;
      track.style.maxWidth = (count * unit - gap) + 'px';
    }

    function updateArrows(){
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      var hasOverflow = track.scrollWidth > track.clientWidth + 1;

      prev.classList.toggle('is-shown', hasOverflow);
      next.classList.toggle('is-shown', hasOverflow);
      prev.classList.toggle('is-visible', hasOverflow && !atStart);
      next.classList.toggle('is-visible', hasOverflow && !atEnd);
    }

    prev.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var unit = getUnit();
      var target = Math.round(track.scrollLeft / unit - 1) * unit;
      track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    });

    next.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var unit = getUnit();
      var target = Math.round(track.scrollLeft / unit + 1) * unit;
      track.scrollTo({ left: Math.min(target, track.scrollWidth - track.clientWidth), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    clampWidth();
    updateArrows();

    var _resizeTimer;
    var card = wrap.closest('product-card') || wrap.parentElement;
    new ResizeObserver(function(){
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(function(){
        clampWidth();
        updateArrows();
      }, 50);
    }).observe(card);
  }

  function init(){
    document.querySelectorAll('[data-card-swatches-wrap]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(function(){
    document.querySelectorAll('[data-card-swatches-wrap]:not([data-bound])').forEach(function(w){
      w.setAttribute('data-bound', '');
      setup(w);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();



/* Shell card swatches: swap the card's imagery from the shared #color_ media map
   and keep the colour label in sync. Cards for ordinary products have no
   [data-shell-card-swatch] elements, so this never fires for them. */
(function shellCardSwatches(){
  function apply(btn){
    var wrap = btn.closest('[data-shell-card-swatches]');
    var card = btn.closest('product-card') || btn.closest('.product-card');
    if (!wrap || !card) return;
    var map;
    try { map = JSON.parse(wrap.getAttribute('data-media-map') || '{}'); } catch(e){ return; }
    var urls = map[btn.getAttribute('data-handle')];
    var label = card.querySelector('[data-shell-card-color-label]');
    if (label) label.textContent = btn.getAttribute('data-label') || '';
    /* Carousel cards: the visible image is a slide, not the primary img, so
       scroll to the slide whose #color_ alt token matches instead of editing srcs. */
    var handle = btn.getAttribute('data-handle');
    var hz = function (v) { return String(v || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
    var imgs = card.querySelectorAll('.product-card__figure img[alt*="#color"], .product-card__media img[alt*="#color"]');
    if (imgs.length > 2) {
      var target = null;
      imgs.forEach(function (im) {
        if (target) return;
        var m = (im.getAttribute('alt') || '').match(/#color[_]([^#]*)/i);
        if (m && hz(m[1]) === handle) target = im;
      });
      if (target) {
        var slide = target.closest('.product-card__media, [class*="slide"], li') || target;
        var scroller = slide.parentElement;
        if (scroller && scroller.scrollWidth > scroller.clientWidth + 4) {
          scroller.scrollTo({ left: slide.offsetLeft - scroller.offsetLeft, behavior: 'instant' });
          return;
        }
        try { slide.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' }); return; } catch (e) {}
      }
    }
    if (!urls || !urls[0]) return;
    var primary = card.querySelector('.product-card__image--primary');
    var secondary = card.querySelector('.product-card__image--secondary');
    if (primary){ primary.removeAttribute('srcset'); primary.src = urls[0]; }
    if (secondary && urls[1]){ secondary.removeAttribute('srcset'); secondary.src = urls[1]; }
  }
  document.addEventListener('change', function(e){
    var input = e.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-shell-card-swatch')) return;
    e.stopPropagation(); /* keep the theme's variant machinery out of it */
    apply(input);
  }, true);
  function initLabels(){
    document.querySelectorAll('[data-shell-card-swatches]').forEach(function(wrap){
      var pressed = wrap.querySelector('[data-shell-card-swatch]:checked');
      if (!pressed) return;
      /* Align the image to the default colour only when the featured image is
         itself colour-specific (shells). Pack cards open on a neutral group
         flatlay, which should stay until the shopper actually picks a colour. */
      var card = wrap.closest('product-card') || wrap.closest('.product-card');
      var primary = card && card.querySelector('.product-card__image--primary');
      var alt = (primary && primary.getAttribute('alt')) || '';
      if (/#color/i.test(alt)) { apply(pressed); return; }
      var label = card && card.querySelector('[data-shell-card-color-label]');
      if (label && !label.textContent) label.textContent = pressed.getAttribute('data-label') || '';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLabels);
  else initLabels();
})();
